/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const InterventionSchema = new Schema({
  assignee: {
    type: 'string',
    maxLength: 100,
    required: true
  },
  assigneeCalledAt: {
    type: 'string',
    format: 'date-time'
    // required: (obj) => obj?.assigneeEmailedAt == null
  },
  assigneeEmailedAt: {
    type: 'string',
    format: 'date-time'
    // required: (obj) => obj?.assigneeCalledAt == null
  },
  description: {
    type: 'string',
    maxLength: 5000
  },
  endDate: {
    type: 'string',
    format: 'date-time'
  },
  estateId: {
    type: 'number',
    required: true
  },
  leaseId: {
    type: 'number'
  },
  noInvoice: {
    type: 'boolean'
  },
  note: {
    type: 'string',
    maxLength: 5000
  },
  priority: {
    type: 'number',
    max: 1,
    min: -1,
    required: true
  },
  requestedAt: {
    type: 'string',
    format: 'date-time',
    required: true
  },
  startDate: {
    type: 'string',
    format: 'date-time'
  },
  subject: {
    type: 'string',
    maxLength: 255,
    required: true
  },
  type: {
    type: 'string',
    maxLength: 50,
    required: true
  }
})

export default InterventionSchema
